import { ModelHelper } from '../classes/model-helper';

/**
 * File upload response data class
 */
export class FileUploadResponseData {
	// Properties
	creationTime: Date;
	creationTimeUtc: Date;
	extension: string;
	fullName: string;
	lastAccessTime: Date;
	lastAccessTimeUtc: Date;
	lastWriteTime: Date;
	lastWriteTimeUtc: Date;
	length: number;
	md5Checksum: string;
	name: string;

	/**
	 * Static mapping function
	 */
	static map(data: any, item: FileUploadResponseData = new FileUploadResponseData()): FileUploadResponseData {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 */
	public map(data: any): FileUploadResponseData {
		ModelHelper.map(data, this, 'creationTime', Date);
		ModelHelper.map(data, this, 'creationTimeUtc', Date);
		ModelHelper.map(data, this, 'extension');
		ModelHelper.map(data, this, 'fullName');
		ModelHelper.map(data, this, 'lastAccessTime', Date);
		ModelHelper.map(data, this, 'lastAccessTimeUtc', Date);
		ModelHelper.map(data, this, 'lastWriteTime', Date);
		ModelHelper.map(data, this, 'lastWriteTimeUtc', Date);
		ModelHelper.map(data, this, 'length');
		ModelHelper.map(data, this, 'md5Checksum');
		ModelHelper.map(data, this, 'name');

		return this;
	}
}
